import { Box, Checkbox, Divider, FormControlLabel, Typography } from "@mui/material"
import type { ReactElement } from "react"
import type { Control } from "react-hook-form"
import { Controller } from "react-hook-form"

import type { WarehouseFilterFormValues } from "@/screens/Warehouses/types"

interface WarehouseFilterSelectFieldProps {
  label: string
  name: "types" | "isActive" | "companyIds"
  control: Control<WarehouseFilterFormValues, any>
  onFilterChange: (name: string, value: any) => void
  optionList: { label: string; value: string }[]
}

export const WarehouseFilterSelectField = <T,>({
  label,
  name,
  control,
  onFilterChange,
  optionList,
}: WarehouseFilterSelectFieldProps): ReactElement => {
  const isOptionSelected = (value: string, selectedValues: string[]) => {
    return (selectedValues ?? []).includes(value)
  }

  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>, value: string, field: any) => {
    const currentValue = Array.isArray(field.value) ? field.value : []
    let newValue: T[]

    if (e.target.checked) {
      newValue = [...currentValue, value]
    } else {
      newValue = currentValue.filter((s: T) => s !== value)
    }

    field.onChange(newValue)
    onFilterChange(name, newValue)
  }

  return (
    <>
      <Typography variant='subtitle1' fontWeight={700} className='px-4 py-1.5 text-gray-700'>
        {label}
      </Typography>
      <Divider />
      <Box className='flex flex-col px-8 py-4' data-test={`warehouse-filter-${name}`}>
        <Controller
          name={name}
          control={control}
          render={({ field }) => (
            <>
              {optionList.map(({ label, value }) => (
                <FormControlLabel
                  key={value}
                  control={
                    <Checkbox
                      onChange={(e) => handleCheckboxChange(e, value, field)}
                      value={value}
                      checked={field.value === true || isOptionSelected(value, field.value as unknown as string[])}
                      data-test={`warehouse-filter-option-${name}-${value}`}
                    />
                  }
                  label={label}
                />
              ))}
            </>
          )}
        />
      </Box>
    </>
  )
}
